import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Button } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import ClipLoader from 'react-spinners/ClipLoader';

const LabConsolleImportFromEasy = forwardRef(function LabConsolleImportFromEasy(props, ref) {
  const [isLoading, setIsLoading] = useState(false);

  // Chiama UPDATE_EASY_EVENTS che legge adSelList dal backend e persiste gli eventi
  const fetchEasy = async (idLab) => {
    const response = await fetch(process.env.REACT_APP_URL_UPDATE_EASY_EVENTS + '?idLab=' + idLab, {
      credentials: 'include',
      method: "GET"
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response;
  };

  // Rilegge gli eventi aggiornati dal backend
  const fetchUsageData = async (idLab) => {
    const response = await fetch(process.env.REACT_APP_URL_GET_USAGE_DATA + '?idLab=' + idLab, {
      credentials: 'include',
      method: "GET"
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    props.setLabEvents(data.schedulerLab || []);
    return data;
  };

  const doImport = async () => {
    if (isLoading) return false;

    setIsLoading(true);
    try {
      // 1. Chiama UPDATE_EASY_EVENTS (il backend legge adSelList e persiste)
      await fetchEasy(props.labProps.idLab);
      // 2. Rileggi gli eventi aggiornati dal backend
      await fetchUsageData(props.labProps.idLab);

      props.setIsSubmitble(1);
      props.setIsSubmitted(1);
      props.setStatusRequest("success");
      return true;
    } catch (error) {
      console.error("Errore nell'importazione da Easy:", error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // Espone doImport al componente padre tramite ref
  useImperativeHandle(ref, () => ({
    doImport
  }));

  const handleClick = async (event) => {
    event.preventDefault();
    await doImport();
  };

  return (
    <React.Fragment>
      {props.buttonDescription ? (
        <Button
          size="small"
          variant="contained"
          onClick={handleClick}
          disabled={isLoading}
          startIcon={isLoading ? null : <SyncIcon />}
        >
          {isLoading ? <ClipLoader size={16} color="#fff" /> : props.buttonDescription}
        </Button>
      ) : null}
    </React.Fragment>
  );
});

export default LabConsolleImportFromEasy;
